import baseUrl from "services/api";
import type {
  FindBasicInformationClientTypes,
  FindCashTypesParms,
  ResponseCardClientParms,
  ResponseFindCashTypes,
  ResponseHistoryBkpTypes,
  ResponseTerminalClientsTypes,
} from "types/clientsTypes";

interface defaultProps {
  idClient: number;
  page?: number;
}

export async function FindBasicCardInfoClientFunctionFunction(
  parms: defaultProps
): Promise<FindBasicInformationClientTypes> {
  const response = await baseUrl.get(
    `infoCliente/infoCliente/${parms.idClient}`
  );

  return response.data;
}

export async function FindInformationCardsClientById(
  parms: defaultProps
): Promise<ResponseCardClientParms> {
  const response = await baseUrl.get(
    `infoCliente/cardCliente/${parms.idClient}`
  );

  return response.data;
}

export async function FindCashTypeClientGraphicById(
  parms: FindCashTypesParms
): Promise<ResponseFindCashTypes[]> {
  const response = await baseUrl.get(
    `infoCliente/vendasNumerario/${parms.idClient}`,
    {
      params: parms,
    }
  );

  return response.data;
}

export async function FindTerminalsByClientId(
  parms: defaultProps
): Promise<PaginateProps<ResponseTerminalClientsTypes[]>> {
  const response = await baseUrl.get(
    `infoCliente/terminaisCliente/${parms.idClient}`,
    {
      params: parms,
    }
  );

  return response.data;
}

export async function FindHistoryBkpById(
  parms: defaultProps
): Promise<PaginateProps<ResponseHistoryBkpTypes[]>> {
  const response = await baseUrl.get(
    `infoCliente/buscaHistoricoBkp/${parms.idClient}`,
    {
      params: parms,
    }
  );

  return response.data;
}

